import {
  SET_AUTH_INIT_DATA,
  SET_USER_DATA,
  SET_WORKSPACES_DATA,
  UPDATE_WORKSPACE_DATA,
  SET_SELECTED_WORKSPACE_ID,
} from "../_actions/types";
import isEmpty from "../_validation/is-empty";
import { cloneDeep } from "lodash";

const initialState = {
  isAuthenticated: false,
  payload: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_AUTH_INIT_DATA: {
      const isAuthenticated = !isEmpty(action.payload);
      const { orgs, ...userData } = action.payload?.user;

      return {
        ...state,
        isAuthenticated,
        payload: isAuthenticated
          ? {
              user: cloneDeep(userData),
              orgs: cloneDeep(action.payload.orgs || []),
              selectedOrg: action.payload.selectedOrg,
            }
          : {},
      };
    }
    case SET_USER_DATA: {
      const { orgs, ...userData } = action.payload;

      return {
        ...state,
        payload: {
          ...state.payload,
          user: userData ? cloneDeep(userData) : null,
        },
      };
    }
    case SET_WORKSPACES_DATA: {
      const workspaceId =
        action.payload?.find((item) => item.id === state.payload?.selectedOrg)
          ?.id ||
        action.payload?.[0]?.id ||
        null;

      return {
        ...state,
        payload: {
          ...state.payload,
          orgs: action.payload ? cloneDeep(action.payload) : null,
          selectedOrg: workspaceId,
        },
      };
    }
    case UPDATE_WORKSPACE_DATA: {
      return {
        ...state,
        payload: {
          ...state.payload,
          orgs: state.payload.orgs.map((org) => {
            if (org.id === action.payload.id) {
              return cloneDeep(action.payload);
            }

            return org;
          }),
        },
      };
    }
    case SET_SELECTED_WORKSPACE_ID: {
      return {
        ...state,
        payload: {
          ...state.payload,
          selectedOrg: action.payload ? Number(action.payload) : null,
        },
      };
    }
    default:
      return state;
  }
}
